/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spread_TemplatesInputs */

const en_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spread Templates`)
};

const es_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantillas de pliego`)
};

const fr_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèles de double page`)
};

const de_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelseiten-Vorlagen`)
};

const ja_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見開きテンプレート`)
};

const zh_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跨页模板`)
};

const ar_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قوالب الصفحات المزدوجة`)
};

const id_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templat Hamparan`)
};

const it_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelli a pagina doppia`)
};

const ru_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шаблоны разворотов`)
};

const pt_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelos de página dupla`)
};

const ko_spread_templates = /** @type {(inputs: Spread_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스프레드 템플릿`)
};

/**
* | output |
* | --- |
* | "Spread Templates" |
*
* @param {Spread_TemplatesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const spread_templates = /** @type {((inputs?: Spread_TemplatesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spread_TemplatesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_spread_templates(inputs)
	if (locale === "es") return es_spread_templates(inputs)
	if (locale === "fr") return fr_spread_templates(inputs)
	if (locale === "de") return de_spread_templates(inputs)
	if (locale === "ja") return ja_spread_templates(inputs)
	if (locale === "zh") return zh_spread_templates(inputs)
	if (locale === "ar") return ar_spread_templates(inputs)
	if (locale === "id") return id_spread_templates(inputs)
	if (locale === "it") return it_spread_templates(inputs)
	if (locale === "ru") return ru_spread_templates(inputs)
	if (locale === "pt") return pt_spread_templates(inputs)
	return ko_spread_templates(inputs)
});